import * as yup from "yup";
import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import { getValidationSchema } from "@Shared/utils/validationSchema";

export interface IBatchesDependenciesFormMeta {
    moduleID: FormInputMeta;
    moduleName: FormInputMeta;

    schema: any;
}

const batchesDependenciesFormMeta = {} as IBatchesDependenciesFormMeta;

batchesDependenciesFormMeta.moduleID = {
    name: 'moduleID',
    type: 'text',
    label: ' ',
    placeholder: 'Module ID',
    validation: yup.string().required('Champ obligatoire !')
};

batchesDependenciesFormMeta.moduleName = {
    name: 'moduleName',
    type: 'text',
    label: ' ',
    placeholder: 'Module Name',
    validation: yup.string().required('Champ obligatoire !')
};


batchesDependenciesFormMeta.schema = yup.object().shape(getValidationSchema(batchesDependenciesFormMeta));

export default batchesDependenciesFormMeta;